import { render, staticRenderFns } from "./ArtisanDialog.vue?vue&type=template&id=fbada35c&scoped=true"
import script from "./ArtisanDialog.vue?vue&type=script&lang=js"
export * from "./ArtisanDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtisanDialog.vue?vue&type=style&index=0&id=fbada35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbada35c",
  null
  
)

export default component.exports